export function solutionIsPublished(solution, agencySolutions) {
    return solution.solutionId == null || agencySolutions.find((agencySolution) => agencySolution.id === solution.solutionId) != null;
}